import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Play, ExternalLink, ChevronLeft, ChevronRight } from 'lucide-react';
import Header from '../components/layout/Header';
import AnnouncementBar from '../components/layout/AnnouncementBar';
import Footer from '../components/layout/Footer';

// Yung Dexy's music info
const artistInfo = {
  name: "Yung Dexy",
  location: "London, UK",
  bio: "UK-based Nigerian artist blending Hip-Hop and Afro-fusion with soulful storytelling. Mixing Nigerian rhythms and rap energy, my music explores love, growth, and identity through lived experience.",
};

// Streaming platforms - Bandcamp FIRST with custom icon
const streamingPlatforms = [
  {
    name: "Bandcamp",
    icon: "https://customer-assets.emergentagent.com/job_5b7c7715-b3c3-4548-9558-b69ad0b92b64/artifacts/vkv63v1b_Unknown.png",
    url: "https://yungdexy.bandcamp.com",
    color: "#1DA0C3",
  },
  {
    name: "Spotify",
    icon: "https://upload.wikimedia.org/wikipedia/commons/1/19/Spotify_logo_without_text.svg",
    url: "https://open.spotify.com/artist/3z5bQVLkH6CwYqsumQO1XN",
    color: "#1DB954",
  },
  {
    name: "Apple Music",
    icon: "https://upload.wikimedia.org/wikipedia/commons/5/5f/Apple_Music_icon.svg",
    url: "https://music.apple.com/gb/artist/yung-dexy/1714640884",
    color: "#FA243C",
  },
  {
    name: "YouTube",
    icon: "https://upload.wikimedia.org/wikipedia/commons/0/09/YouTube_full-color_icon_%282017%29.svg",
    url: "https://youtube.com/@itsyungdexy",
    color: "#FF0000",
  },
];

// Social media links for floating icons
const socialMediaLinks = [
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@itsyungdexy04",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
      </svg>
    ),
    color: "#000000",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/itsyungdexy/",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    color: "#E4405F",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@itsyungdexy",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    color: "#FF0000",
  },
];

// Popular tracks - all redirect to Bandcamp
const popularTracks = [
  { title: "Aye Mi", plays: "13,257", duration: "2:51", url: "https://yungdexy.bandcamp.com" },
  { title: "Man of the Year (Moty)", plays: "6,157", duration: "3:16", url: "https://yungdexy.bandcamp.com" },
  { title: "Interest", plays: "10,024", duration: "2:53", url: "https://yungdexy.bandcamp.com" },
  { title: "I Pray", plays: "5,404", duration: "2:26", url: "https://yungdexy.bandcamp.com" },
  { title: "Call Me", plays: "3,583", duration: "2:43", url: "https://yungdexy.bandcamp.com" },
];

// Singles for the slideshow at the top - all redirect to Bandcamp main page
const singles = [
  { 
    title: "My P", 
    type: "Single", 
    year: "2025",
    artwork: "https://customer-assets.emergentagent.com/job_5b7c7715-b3c3-4548-9558-b69ad0b92b64/artifacts/qnckfei3_84bbc802-3c56-4ad9-a3c0-ce93a99a6f01.JPG",
    url: "https://yungdexy.bandcamp.com",
  },
  { 
    title: "Aye Mi", 
    type: "Single", 
    year: "2025",
    artwork: "https://customer-assets.emergentagent.com/job_5b7c7715-b3c3-4548-9558-b69ad0b92b64/artifacts/4rqyisth_630c5c1f-fba5-4fcc-9911-b8d4facf1f76.JPG",
    url: "https://yungdexy.bandcamp.com",
  },
  { 
    title: "Blow My Mind", 
    type: "Single", 
    year: "2025",
    artwork: "https://customer-assets.emergentagent.com/job_5b7c7715-b3c3-4548-9558-b69ad0b92b64/artifacts/962boulm_b298d57d-d6e4-4177-add0-145c51df21c3.JPG",
    url: "https://yungdexy.bandcamp.com",
  },
  { 
    title: "MYP", 
    type: "Single", 
    year: "2025",
    artwork: "https://customer-assets.emergentagent.com/job_5b7c7715-b3c3-4548-9558-b69ad0b92b64/artifacts/ilebfbd4_c9e9241a-a534-42fc-8b1c-c433c869988a.JPG",
    url: "https://yungdexy.bandcamp.com",
  },
];

// Albums & EPs only for discography section - redirect to Bandcamp
const albumsAndEPs = [
  { 
    title: "Worries & Cherries", 
    type: "Album", 
    year: "2024",
    artwork: "https://f4.bcbits.com/img/a4288606291_10.jpg",
    url: "https://yungdexy.bandcamp.com",
  },
  { 
    title: "Benin Boy Loving (B.B.L)", 
    type: "EP", 
    year: "2025",
    artwork: "https://customer-assets.emergentagent.com/job_5b7c7715-b3c3-4548-9558-b69ad0b92b64/artifacts/19f7b784_24a12a27-a925-4e94-9143-2c3c4e33dcda.JPG",
    url: "https://yungdexy.bandcamp.com",
  },
];

// Floating Social Icon Component
const FloatingSocialIcon = ({ social, index }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  
  useEffect(() => {
    // Random starting position
    const startX = Math.random() * 100;
    const startY = 20 + Math.random() * 60;
    setPosition({ x: startX, y: startY });
    
    // Animation loop
    const animate = () => {
      setPosition(prev => ({
        x: prev.x + (Math.sin(Date.now() / 2000 + index) * 0.3),
        y: prev.y + (Math.cos(Date.now() / 3000 + index) * 0.2),
      }));
    };
    
    const interval = setInterval(animate, 50);
    return () => clearInterval(interval);
  }, [index]);

  return (
    <a
      href={social.url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed z-40 p-3 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 hover:scale-125 transition-all duration-300 shadow-lg"
      style={{
        left: `${Math.min(Math.max(position.x, 5), 90)}%`,
        top: `${Math.min(Math.max(position.y, 15), 85)}%`,
        color: social.color,
      }}
      title={social.name}
    >
      {social.icon}
    </a>
  );
};

const MusicPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-advance singles slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % singles.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] via-[#2d1f3d] to-[#1a1a1a] relative">
      <AnnouncementBar />
      <Header />
      
      {/* Floating Social Media Icons */}
      {socialMediaLinks.map((social, index) => (
        <FloatingSocialIcon key={social.name} social={social} index={index} />
      ))}
      
      <main className="pb-20 relative z-10">
        {/* Singles Slideshow Section */}
        <div className="w-full max-w-4xl mx-auto px-4 pt-8">
          <h2 className="text-white/60 text-xs tracking-widest text-center mb-4">LATEST SINGLES</h2>
          
          {/* Slideshow Container with Arrows Outside */}
          <div className="flex items-center justify-center gap-4">
            {/* Left Arrow - Outside */}
            <button
              onClick={() => setCurrentSlide((prev) => (prev - 1 + singles.length) % singles.length)}
              className="flex-shrink-0 bg-white/10 hover:bg-white/20 text-white p-3 rounded-full transition-all"
            >
              <ChevronLeft size={24} />
            </button>
            
            {/* Slideshow */}
            <div className="relative rounded-xl overflow-hidden shadow-2xl aspect-square max-h-[400px] w-full max-w-sm bg-black">
              {/* Slideshow Images */}
              {singles.map((single, index) => (
                <a
                  key={single.title}
                  href={single.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`absolute inset-0 transition-opacity duration-700 ${
                    currentSlide === index ? 'opacity-100' : 'opacity-0 pointer-events-none'
                  }`}
                >
                  <img 
                    src={single.artwork} 
                    alt={single.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4">
                    <p className="text-white font-bold text-lg">{single.title}</p>
                    <p className="text-white/60 text-sm">{single.type} • {single.year}</p>
                  </div>
                </a>
              ))}
              
              {/* Slideshow Indicators */}
              <div className="absolute bottom-4 right-4 flex gap-1.5 z-10">
                {singles.map((_, index) => (
                  <button
                    key={index}
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentSlide(index);
                    }}
                    className={`w-2 h-2 rounded-full transition-all ${
                      currentSlide === index ? 'bg-white w-5' : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </div>
            
            {/* Right Arrow - Outside */}
            <button
              onClick={() => setCurrentSlide((prev) => (prev + 1) % singles.length)}
              className="flex-shrink-0 bg-white/10 hover:bg-white/20 text-white p-3 rounded-full transition-all"
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>

        {/* Artist Info Section - Removed album artwork and monthly listeners */}
        <div className="max-w-4xl mx-auto px-4 pt-8 pb-8 relative z-10">
          <div className="flex flex-col items-center">
            {/* Artist Name */}
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-2 text-center">
              {artistInfo.name}
            </h1>
            <p className="text-white/60 text-sm">{artistInfo.location}</p>
          </div>
        </div>

        {/* Streaming Platforms */}
        <div className="max-w-2xl mx-auto px-4 py-8">
          <h2 className="text-white/60 text-xs tracking-widest text-center mb-6">STREAM NOW</h2>
          <div className="grid grid-cols-2 gap-4">
            {streamingPlatforms.map((platform) => (
              <a
                key={platform.name}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-white/10 hover:bg-white/20 rounded-lg p-4 transition-all group"
              >
                <div 
                  className="w-12 h-12 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: platform.color + '20' }}
                >
                  <img 
                    src={platform.icon} 
                    alt={platform.name} 
                    className="w-6 h-6"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
                <span className="text-white font-medium group-hover:text-white/80 transition-colors">
                  {platform.name}
                </span>
                <ExternalLink size={14} className="text-white/40 ml-auto" />
              </a>
            ))}
          </div>
        </div>

        {/* Popular Tracks */}
        <div className="max-w-2xl mx-auto px-4 py-8">
          <h2 className="text-white text-xl font-bold mb-6">Popular</h2>
          <div className="space-y-2">
            {popularTracks.map((track, index) => (
              <a
                key={track.title}
                href={track.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-white/5 hover:bg-white/10 rounded-lg p-3 transition-all cursor-pointer group"
              >
                <span className="text-white/40 w-6 text-center">{index + 1}</span>
                <div className="flex-1">
                  <p className="text-white font-medium group-hover:text-green-400 transition-colors">{track.title}</p>
                  <p className="text-white/40 text-sm">{track.plays} plays</p>
                </div>
                <span className="text-white/40 text-sm">{track.duration}</span>
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <Play size={14} className="text-white ml-0.5" />
                </div>
              </a>
            ))}
          </div>
          <p className="text-white/40 text-xs text-center mt-4">Click to play on Bandcamp</p>
        </div>

        {/* Albums & EPs Section */}
        <div className="max-w-2xl mx-auto px-4 py-8">
          <h2 className="text-white text-xl font-bold mb-6">Albums & EPs</h2>
          <div className="grid grid-cols-2 gap-4">
            {albumsAndEPs.map((release) => (
              <a
                key={release.title}
                href={release.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/5 hover:bg-white/10 rounded-lg p-4 transition-all cursor-pointer group"
              >
                <div className="w-full aspect-square bg-black/50 rounded-lg mb-3 flex items-center justify-center overflow-hidden relative">
                  <img 
                    src={release.artwork} 
                    alt={release.title}
                    className="w-full h-full object-cover"
                  />
                  {/* Play overlay */}
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                      <Play size={20} className="text-white ml-1" />
                    </div>
                  </div>
                </div>
                <p className="text-white font-medium text-sm truncate group-hover:text-green-400 transition-colors">{release.title}</p>
                <p className="text-white/40 text-xs">{release.type} • {release.year}</p>
              </a>
            ))}
          </div>
        </div>

        {/* About */}
        <div className="max-w-2xl mx-auto px-4 py-8">
          <h2 className="text-white text-xl font-bold mb-4">About</h2>
          <p className="text-white/70 leading-relaxed">{artistInfo.bio}</p>
          <div className="mt-6 pt-6 border-t border-white/10">
            <p className="text-white/40 text-sm">Contact: contactdexy@gmail.com</p>
          </div>
        </div>

        {/* Back to Shop */}
        <div className="max-w-2xl mx-auto px-4 py-8 text-center">
          <Link
            to="/shop"
            className="inline-block bg-white text-black px-8 py-3 font-bold tracking-wider hover:bg-gray-200 transition-colors"
          >
            SHOP MERCH
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MusicPage;
